import { __extends } from "tslib";
import * as React from 'react';
import { namespacedClassnames } from '../../common/namespace-classes';
import { XIcon, SearchIcon } from '../../icons/icons-components';
import { DeprecatedInput } from '../../primitives/deprecated-input/input';
import * as classNames from 'classnames';
export var searchInputKey = 'search-input';
var SearchInput = /** @class */ (function (_super) {
    __extends(SearchInput, _super);
    function SearchInput() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            isFocused: false,
            hasValue: false
        };
        _this.onChange = function (query) {
            _this.setState({ hasValue: !!query.length });
            _this.props.onSearch(query);
        };
        _this.onFocus = function () {
            _this.setState({ isFocused: true });
            if (_this.props.onFocusChange) {
                _this.props.onFocusChange(true);
            }
        };
        _this.onBlur = function () {
            _this.setState({ isFocused: false });
            if (_this.props.onFocusChange) {
                _this.props.onFocusChange(false);
            }
        };
        return _this;
    }
    SearchInput.prototype.render = function () {
        var props = this.props;
        var query = props.query, disabled = props.disabled, placeholder = props.placeholder, forceExpanded = props.forceExpanded, autoFocus = props.autoFocus;
        var isFocused = this.state.isFocused;
        var isExpanded = forceExpanded || isFocused || !!query;
        var inputClassNames = classNames({
            'has-value': !!query,
            'is-focused': isFocused,
            'is-expanded': isExpanded,
            'full-width': isExpanded && props.fullWidth,
        }, props.className);
        var searchInputClassNames = namespacedClassnames(searchInputKey, disabled ? 'is-disabled' : null);
        var resetSearchBtn = !query ? null : (React.createElement("span", { className: 'reset-search-btn', onClick: this.props.onReset },
            React.createElement(XIcon, null)));
        return (React.createElement("span", { className: searchInputClassNames },
            React.createElement(SearchIcon, null),
            React.createElement(DeprecatedInput, { autoFocus: autoFocus, className: inputClassNames, value: query, onChange: this.onChange, disabled: disabled, onFocus: this.onFocus, onBlur: this.onBlur, placeholder: placeholder, onKeyDown: props.onKeyDown, tooltipRelativeToBody: props.tooltipRelativeToBody }),
            resetSearchBtn));
    };
    return SearchInput;
}(React.Component));
export { SearchInput };
//# sourceMappingURL=search-input.js.map